/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum WarmingQuestionType {
  text = "text",
  radio = "radio",
  checkbox = "checkbox",
  date = "date",
}

export const WarmingQuestionTypeDisplay: Record<WarmingQuestionType, string> = {
  [WarmingQuestionType.text]: "Text",
  [WarmingQuestionType.radio]: "Radio",
  [WarmingQuestionType.checkbox]: "Checkbox",
  [WarmingQuestionType.date]: "Date",
};
